/**
 * Created by m.igrachev on 7/24/2017.
 */
import determineResponsiveMode from "./determineResponsiveMode";
import { isOutOfWindowViewport, getBoundingClientRectObject } from "./isOutOfWindowViewport";

export default {
    determineResponsiveMode: determineResponsiveMode,
    isOutOfWindowViewport: isOutOfWindowViewport,
    getBoundingClientRectObject: getBoundingClientRectObject
};
